export const WINNER = {
    name: 'WINNER',
    code: '243'
};

export const TOTAL_HOME_RUNS_UNDER_OVER_5_5 = {
    name: 'TOTAL_HOME_RUNS_UNDER_OVER',
    code: '244'
};
export const TOTAL_HOME_RUNS= {
    name: 'TOTAL_HOME_RUNS',
    code: '245'
};


// export const DOUBLE_CHANCE_1 = '13' export const DOUBLE_CHANCE_2 = '14'
export const SCORE = {
    name: 'CORRECT_SCORE',
    code: '246'
};

export const WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER = {
    name: 'WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER',
    code: '247'
};


export const BATTER1_HOME_RUNS = {
    name: 'BATTER1_HOME_RUNS',
    code: '248'
};
export const BATTER2_HOME_RUNS = {
    name: 'BATTER2_HOME_RUNS',
    code: '249'
};
export const TOTAL_HOME_RUNS_OVER_UNDER_4_5 = {
    name: 'TOTAL_HOME_RUNS_UNDER_OVER',
    code: '250'
};
export const TOTAL_HOME_RUNS_OVER_UNDER_6_5 = {
    name: 'TOTAL_HOME_RUNS_UNDER_OVER',
    code: '251'
};
export const UNDER_OVER = {
    name: 'TOTAL_HOME_RUNS_UNDER_OVER',
    code: 'UNDER_OVER'
};

export const ALL_BASEBALL_MARKETS = [
    WINNER,
    UNDER_OVER,
    TOTAL_HOME_RUNS,
    SCORE,
    WINNER_AND_TOTAL_HOME_RUNS_OVER_UNDER,
    BATTER1_HOME_RUNS,
    BATTER2_HOME_RUNS,
    TOTAL_HOME_RUNS_OVER_UNDER_4_5,
    TOTAL_HOME_RUNS_OVER_UNDER_6_5,
    TOTAL_HOME_RUNS_UNDER_OVER_5_5,
];


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/constants/marketTypes.js